import React from 'react';
import {Link} from 'react-router-dom';

import './Button.css'
import {Button, Icon} from "@gravity-ui/uikit";
import {Pencil, Plus, TrashBin} from "@gravity-ui/icons";

function MyButton({children, onClick, type, to, className, disabled}) {
    const buttonProps = {
        className: `my-button ${className || ''}`,
        onClick: onClick,
        type: type || 'button',
        disabled: disabled || false,
    };

    return to ? <Link to={to} {...buttonProps}>{children}</Link> : <button {...buttonProps}>{children}</button>;
}

export default MyButton;

export function EditButtonIcon({onClick}) {
    return (
        <Button view={"normal"} size={"m"} onClick={onClick}>
            <Icon data={Pencil} size={18}/>
        </Button>
    );
}

export function DeleteButtonIcon({onClick}) {
    return (
        <Button view={"flat-danger"} size={"m"} onClick={onClick}>
            <Icon data={TrashBin} size={18}/>
        </Button>
    );
}

export function AddButtonMaxWidth({text, onClick}) {
    return (
        <Button className="add-button_max-width" view={"action"} size={"xl"} width="max" onClick={onClick}>
            {text}
            <Icon data={Plus} size={18}/>
        </Button>
    );
}